export default "__VITE_ASSET__WfUTTfNt__"